module.exports = __webpack_public_path__ + "img/making-it-official.20faaba6.png";